import type { Conversation, ConversationMode, GetUseAnalyticsResult } from '../types/tutorUsage';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

function isoDayOffset(base: Date, daysAgo: number, hour = 12, minute = 0): string {
  const date = new Date(base.getTime() - daysAgo * MS_PER_DAY);
  date.setHours(hour, minute, 0, 0);
  return date.toISOString();
}

function buildConversation(id: string, userId: string, mode: ConversationMode, messageOffsets: Array<[number, number, number]>, base: Date): Conversation {
  return {
    id,
    userId,
    mode,
    userMessages: messageOffsets.map(([daysAgo, hour, minute]) => ({
      createdAt: isoDayOffset(base, daysAgo, hour, minute),
    })),
  };
}

function buildMockUseAnalytics(): GetUseAnalyticsResult {
  const now = new Date();
  const endDate = now.toISOString();
  const startDate = new Date(now.getTime() - 7 * MS_PER_DAY).toISOString();

  const userA = 'mock-user-a';
  const userB = 'mock-user-b';
  const userC = 'mock-user-c';
  const userD = 'mock-user-d';

  const currentPeriod: Conversation[] = [
    buildConversation('conv-1', userA, 'STUDY_MODE', [[1, 10, 15], [1, 10, 22], [2, 11, 0]], now),
    buildConversation('conv-2', userA, 'PRACTICE_MODE', [[3, 9, 30], [4, 16, 5]], now),
    buildConversation('conv-3', userB, 'STUDY_MODE', [[1, 12, 45], [2, 12, 50], [2, 13, 10], [5, 18, 0]], now),
    buildConversation('conv-4', userC, 'STUDY_MODE', [[0, 14, 0]], now),
    buildConversation('conv-5', userC, 'PRACTICE_MODE', [[2, 9, 0], [3, 10, 30]], now),
    buildConversation('conv-6', userD, 'REVISION_MODE', [[4, 8, 30], [6, 17, 0]], now),
  ];

  const previousPeriod: Conversation[] = [
    buildConversation('prev-1', userA, 'STUDY_MODE', [[8, 10, 0], [9, 11, 30]], now),
    buildConversation('prev-2', userB, 'PRACTICE_MODE', [[10, 14, 0], [11, 15, 20], [12, 9, 0]], now),
    buildConversation('prev-3', userC, 'STUDY_MODE', [[10, 16, 0]], now),
  ];

  return {
    startDate,
    endDate,
    totalUsers: 25,
    conversations: { currentPeriod, previousPeriod },
  };
}

function getMockUseAnalytics(): GetUseAnalyticsResult {
  return buildMockUseAnalytics();
}

export { getMockUseAnalytics };
